// Import images
import deltabarPreview from '../img/indicators/OTM_DELTA_BAR_FREE.jpg';
import vwapPreview from '../img/indicators/OTM_VWAP_FREE.jpg';

export const FreeIndicatorsDataEn = [
  {
    id: 'deltabar',
    title: 'OTM DeltaBar Free Version',
    image: deltabarPreview,
    description: "OTM DeltaBar Free allows you to visualize the behavior of cumulative delta and bar delta direction with the same precision and performance as the full version. Ideal for traders who want to analyze buying and selling pressure in each candle without technical limitations. It’s an excellent introduction to the analytical power of order flow offered by the OTM suite.",
    features: [
      "Session cumulative delta",
      "Per-bar delta direction",
      "Professional interface",
      "Full compatibility"
    ],
    downloadLink: "https://otmtrading.lemonsqueezy.com/buy/c390bb14-4ebb-4c43-a173-b7b0a3b21a6e"
  },
  {
    id: 'vwap',
    title: 'OTM VWAP Free Version',
    image: vwapPreview,
    description: "OTM VWAP Free gives you access to the daily VWAP for free — an essential tool to identify balance zones and institutional levels. With the same design, accuracy, and performance as the full version, you can understand price dynamics in relation to volume with a clear and reliable reference.",
    features: [
      "Central daily VWAP and its deviations",
      "Dynamic support and resistance",
      "Professional design",
      "Easy to interpret"
    ],
    downloadLink: "https://otmtrading.lemonsqueezy.com/buy/e8c577fe-a88a-4829-841a-e77ca5ad8b0d"
  }
];


export const FreeIndicatorsDataEs = [
  {
    id: 'deltabar',
    title: 'OTM DeltaBar Versión Gratuita',
    image: deltabarPreview,
    description: "OTM DeltaBar Free te permite visualizar el comportamiento del delta acumulado y la dirección del delta por barra con la misma precisión y rendimiento de la versión completa. Ideal para traders que desean analizar la presión de compra y venta en cada vela sin limitaciones técnicas. Es una excelente introducción al poder analítico del flujo de órdenes que ofrece la suite OTM.",
    features: [
      "Delta acumulado de sesión",
      "Dirección del delta por barra",
      "Interfaz profesional",
      "Compatibilidad total"
    ],
    downloadLink: "https://otmtrading.lemonsqueezy.com/buy/c390bb14-4ebb-4c43-a173-b7b0a3b21a6e"
  },
  {
    id: 'vwap',
    title: 'OTM VWAP Versión Gratuita',
    image: vwapPreview,
    description: "OTM VWAP Free te ofrece la versión gratuita del reconocido VWAP diario, una herramienta esencial para identificar zonas de equilibrio y niveles institucionales. Con el mismo diseño, precisión y rendimiento que la versión completa, podrás entender la dinámica del precio respecto al volumen con una referencia clara y confiable.",
    features: [
      "VWAP diario central y sus desviaciones",
      "Soporte y resistencia dinámica",
      "Diseño profesional",
      "Fácil de interpretar"
    ],
    downloadLink: "https://otmtrading.lemonsqueezy.com/buy/188d1410-ef7c-46e0-8a8c-f215f0888767"
  }
];
